import { IDataStorage } from '../internal/data-storage';
import { InternalIndex } from '../internal/internal-index';
import { InternalTable } from '../internal/internal-table';

export class User implements IDataStorage {
  usernameIndex: InternalIndex = new InternalIndex(
    'Username',
    'Username',
    true,
    false
  );
  tableDefinition: InternalTable = new InternalTable('Users', 'Id', true, [
    this.usernameIndex
  ]);

  Id: number;
  Username: string;
  Token: string;
  LastAuthenticationDate: Date;
  LastLoggedInDate: Date;
  Pin: string;

  static getTableDefinition(): InternalTable {
    return new User().tableDefinition;
  }
}
